<template>
  <a-modal
    :visible="visible"
    :title="$t('retailSale.setupIssue.title')"
    :closable="false"
    :maskClosable="false"
    :keyboard="false"
    :footer="null"
    wrapClassName="retail-setup-issue-modal"
  >
    <template #title>
      <div class="retail-setup-issue-title">
        <span class="retail-setup-issue-title-icon">
          <i class="fas fa-exclamation-triangle"></i>
        </span>
        <span class="retail-setup-issue-title-copy">
          <small>{{ $t('retailSale.setupIssue.attention') }}</small>
          <strong>{{ $t('retailSale.setupIssue.title') }}</strong>
        </span>
      </div>
    </template>

    <div class="retail-setup-issue-message">
      <i class="fas fa-info-circle"></i>
      <p>{{ $t('retailSale.setupIssue.message') }}</p>
    </div>
    <ul class="retail-setup-issue-list" aria-live="polite">
      <li v-for="item in missingItems" :key="item">
        <span class="retail-setup-issue-item-icon">
          <i class="fas fa-exclamation-circle"></i>
        </span>
        <span>{{ item }}</span>
      </li>
    </ul>
    <div class="retail-setup-issue-actions">
      <a-button @click="$emit('back')">
        <i class="fas fa-arrow-left"></i>
        {{ $t('retailSale.setupIssue.back') }}
      </a-button>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'RetailSetupIssueModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    missingItems: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(value) {
        this.setModalMaskState(value)
      }
    }
  },
  beforeDestroy() {
    this.setModalMaskState(false)
  },
  methods: {
    setModalMaskState(visible) {
      if (typeof document === 'undefined') return

      document.body.classList.toggle('retail-setup-issue-open', visible)
    }
  }
}
</script>

<style src="../../styles/retail-setup-issue-modal.css"></style>
